"use client";

import { baseApi } from "./baseApi";

const authApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    login: builder.mutation({
      query: (credential: {
        agent_email_or_username: string;
        agent_password: string;
      }) => ({
        url: "/authentication/agentLogin",
        method: "POST",
        body: credential,
      }),
    }),
  }),
});

export const { useLoginMutation } = authApi;
